/**
 * The device's Back closes what is open over the page — a panel from the right, a dialog — the
 * last opened first, instead of leaving the page (on a phone Back is how one closes things).
 *
 * Nothing is added to the browser's history: the navigation Back starts is stopped by a router
 * guard (the router puts the address back), and the top overlay closes instead. With nothing
 * open, Back goes back as always.
 */
const open = []

/** Register an overlay while it is open; returns the function that unregisters it. */
export function closesOnBack(close) {
  const entry = { close }
  open.push(entry)
  return () => {
    const i = open.indexOf(entry)
    if (i >= 0) open.splice(i, 1)
  }
}

/** Close the top overlay, if there is one. */
export function closeTop() {
  const top = open[open.length - 1]
  if (!top) return false
  top.close()
  return true
}

/**
 * Install on the router before its other guards: a navigation that Back (or Forward) started
 * while an overlay is open is stopped, and the overlay closes.
 *
 * Back is recognised by the history entry: Back has already moved the browser to the entry it
 * goes to when the guards run (the router's own state there names that address), while a
 * navigation the app starts moves the entry only after them. No listener of the browser's
 * popstate is needed — which could not be relied on to run before the router's own.
 */
export function installBackCloses(router) {
  router.beforeEach((to, from) => {
    const entry = typeof window !== 'undefined' ? window.history.state : null
    const traversed = !!entry && entry.current === to.fullPath && to.fullPath !== from.fullPath
    if (traversed && closeTop()) return false
    return true
  })
}
